import React, { useCallback, useEffect, useState } from "react";
import { useParams, Route, Switch, useHistory } from "react-router-dom";
import axios from "axios";

import Loading from "../../components/Loading";
import EventParticipationSubmissionProvider from "../../context/EventParticipationSubmissionManager";
import EventParticipationNawForm from "./EventParticipationNawForm";
import EventParticipationVehicleForm from "./EventParticipationVehicleForm";
import EventParticipationFieldsForm from "./EventParticipationFieldsForm";
import EventParticipationSubmissionSidebarLayout from "./components/EventParticipationSubmissionSidebarLayout";
import EventParticipationSubmissionPage from "./EventParticipationSubmissionPage";
import EventParticipationSubmissionSuccessPage from "./EventParticipationSubmissionSuccessPage";

function EventParticipationSubmissionWrapper() {
    const { eventId } = useParams();
    const [event, setEvent] = useState(null);
    const [error, setError] = useState(null);
    const history = useHistory();
    const refreshEvent = useCallback(async () => {
        setEvent(null);
        setError(null);
        try {
            const response = await axios.post("/getEvent", { eventId: eventId });
            setEvent(response.data.event);
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout bij het ophalen van het evenement. Probeer het later opnieuw.");
        }
    }, [eventId]);

    useEffect(() => {
        refreshEvent();
    }, [refreshEvent]);

    if (error) {
        return (
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <div className="alert alert-danger m-4">{error}</div>
                </div>
            </div>
        );
    }

    if (!event) {
        return (
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <Loading />
                </div>
            </div>
        );
    }

    if (event && !event.eventParticipationSubmissionsEnabled) {
        history.replace(`/event/${eventId}`);
        return null;
    }

    return (
        <EventParticipationSubmissionProvider eventId={eventId} event={event}>
            <Switch>
                <Route exact path="/event/:eventId/participation-submission">
                    <EventParticipationSubmissionPage event={event} />
                </Route>
                <Route path="/event/:eventId/participation-submission/naw">
                    <EventParticipationSubmissionSidebarLayout>
                        <EventParticipationNawForm event={event} />
                    </EventParticipationSubmissionSidebarLayout>
                </Route>
                <Route path="/event/:eventId/participation-submission/vehicle">
                    <EventParticipationSubmissionSidebarLayout>
                        <EventParticipationVehicleForm event={event} />
                    </EventParticipationSubmissionSidebarLayout>
                </Route>
                <Route path="/event/:eventId/participation-submission/fields">
                    <EventParticipationSubmissionSidebarLayout>
                        <EventParticipationFieldsForm event={event} />
                    </EventParticipationSubmissionSidebarLayout>
                </Route>
                <Route path="/event/:eventId/participation-submission/success">
                    <EventParticipationSubmissionSidebarLayout>
                        <EventParticipationSubmissionSuccessPage event={event} />
                    </EventParticipationSubmissionSidebarLayout>
                </Route>
            </Switch>
        </EventParticipationSubmissionProvider>
    );
}

export default EventParticipationSubmissionWrapper;
